import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2022')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('autoethnography') || media.includes('installation');
  })
  .slice(0, 4);

export default function MiraeKhRhee() {
  const slides = [
    { src: '/uploads/2022/07/RHEE_kate-hers_PORTFOLIO-1.jpg', alt: 'Kate-hers Rhee work 1' },
    { src: '/uploads/2022/07/RHEE_kate-hers_PORTFOLIO-3.jpg', alt: 'Kate-hers Rhee work 2' },
    { src: '/uploads/2022/07/RHEE_kate-hers_PORTFOLIO-5.jpg', alt: 'Kate-hers Rhee work 3' },
    { src: '/uploads/2022/07/RHEE_kate-hers_PORTFOLIO-8.jpg', alt: 'Kate-hers Rhee work 4' },
    { src: '/uploads/2022/07/RHEE_kate-hers_PORTFOLIO-9.jpg', alt: 'Kate-hers Rhee work 5' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Mirae Kh Rhee</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Mirae Kh Rhee slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2022</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>The KAFA juror committee of 2022, comprised of Helen Molesworth, Virginia Moon, and Rebecca Lowery, was presented with a strong and diverse pool of applicants. After a lively and critical exchange of compelling viewpoints, the committee agreed to nominate kate-hers RHEE for this year’s grant. RHEE’s trajectory as an artist has been propelled by a dedication to learning about and confronting the Korean culture from which she was separated as an adopted child; her clever, thoughtful mixture of mediums in this endeavor deftly traffics in complexity and humor. What impressed us most about RHEE’s work was its sophisticated layering of motifs borrowed from historical Korean art with contemporary conceptual sensibilities: it is a rich and compelling admixture that we have no doubt will continue to expand in depth and breadth.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Helen Molesworth, Writer and Curator</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Virginia Moon, Associate Curator of Korean Art, Los Angeles Contemporary Museum of Art</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Rebecca Lowery, Associate Curator, Museum of Contemporary Art, Los Angeles</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>South Korean born social practice artist kate-hers RHEE’s transnational life experiences led her to work between the United States, South Korea, and Germany, where learning foreign languages, code-switching, and cultural traditions and customs continuously inform her artwork. Their notable solo exhibitions include: Inventing Genealogies, New Media Artspace, Baruch College, NY (2021), Unfinished Business, SOMA Artspace, Berlin (2021), Mourning Becomes Electra, Warehouse Gallery, Incheon, South Korea (2019), and I like Korea and Korea likes me, Gallery damdam, Korean Cultural Center, Berlin (2018). Upcoming exhibitions include locations at Tieranatomisches Theater Berlin; Museum am Rothenbaum, Kulturen und Künste der Welt, Hamburg; and the Paul Robeson Galleries at Rutgers University, Newark. RHEE’s work has been supported by grants and fellowships from the Berlin Senate Cultural Administration, Foundation for the Contemporary Arts, the AHL Foundation, Puffin Foundation, Heinrich Böll Stiftung, DAAD,  Fulbright, among others, and in 2021 RHEE was selected for the German Arts Council Women in Media and Culture Mentoring Program.</p>

            <a href='https://katehersrhee.com/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
